import * as dateConf from '@/configuration/datePickerConf';
import formatDate from '@/services/general/formatIsoDate';
import ucFirst from '@/services/general/ucFirst';

export default function genererDispoParJour(dispoAllDays) {
  const dispoFaceInMonth = [];
  let actualMonth = {
    mois: ucFirst(dateConf.LISTE_MOIS[0]),
    days: [],
  };
  let month = 1;
  dispoAllDays.forEach((dispoParjour) => {
    if (dispoParjour.mois !== month) {
      dispoFaceInMonth.push(actualMonth);
      month += 1;
      actualMonth = {
        mois: ucFirst(dateConf.LISTE_MOIS[dispoParjour.mois - 1]),
        days: [],
      };
    }
    if (formatDate(dispoParjour.date) === formatDate(new Date())) {
      dispoParjour.isToday = true;
    } else dispoParjour.isToday = false;
    dispoParjour.day = new Date(dispoParjour.date).getDate();
    actualMonth.days.push(dispoParjour);
  });
  dispoFaceInMonth.push(actualMonth);
  return dispoFaceInMonth;
}
